// import axios from 'axios'
// import { urls } from '@/config'
import VideoPlayer from '../../components/play/video.js'
import '@/directives/track'

export default {
  data() {
    return {
      videoInfo: {},
      commentId: `${window.ued.videoInfo.oldVid}_V_90008`,
    }
  },
  components: {
    'video-player': VideoPlayer
  },
  methods: {
    getVideoInfo() {
      this.videoInfo = window.ued.videoInfo
    },
  },
  mounted() {
    this.getVideoInfo()
  }
}
